"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileExtensionBadge = void 0;
var tslib_1 = require("tslib");
var file_extension_1 = (0, tslib_1.__importDefault)(require("file-extension"));
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var theme_1 = require("../../theme");
var colors_1 = require("../../theme/colors");
var flexbox_1 = require("../flexbox");
var icons_1 = require("../icons");
var mini_icons_1 = require("../mini-icons");
function colorMap(extn) {
    switch (extn) {
        case 'doc':
        case 'docx':
        case 'odt':
            return colors_1.colors.brand[400];
        case 'eml':
        case 'msg':
            return colors_1.colors.steel[400];
        case 'exe':
            return colors_1.colors.steel[500];
        case 'exl':
        case 'xls':
        case 'xlsx':
        case 'ods':
            return '#1C917C';
        case 'pdf':
            return colors_1.colors.fire[600];
        case 'png':
            return '#6363c5';
        case 'jpg':
        case 'jpeg':
            return colors_1.colors.fire[400];
        case 'txt':
            return colors_1.colors.steel[300];
        default:
            return colors_1.colors.steel[200];
    }
}
function FileExtensionBadge(_a) {
    var fileName = _a.fileName, extension = _a.extension;
    if (!fileName && !extension)
        return react_1.default.createElement("div", null);
    var extn = extension || (0, file_extension_1.default)(fileName);
    var extensionValue = extn;
    if (extn === 'eml') {
        extensionValue = react_1.default.createElement(icons_1.IconEmail, null);
    }
    if (fileName && fileName.toLowerCase() === extn) {
        extensionValue = react_1.default.createElement(mini_icons_1.MiniIconDocument, { color: "#fff" });
    }
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(StyledExtensionBadge, { color: colorMap(extn.toLowerCase()) },
            react_1.default.createElement(flexbox_1.Flexbox, { justifyContent: "center", alignItems: "center", height: "24px", width: "24px" }, extensionValue))));
}
exports.FileExtensionBadge = FileExtensionBadge;
var StyledExtensionBadge = styled_components_1.default.div(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  background-color: ", ";\n  border-radius: 50%;\n  color: #fff;\n  font-family: ", ";\n  font-weight: 600;\n  font-size: 8px;\n  height: 24px;\n  line-height: 1;\n  text-rendering: optimizeLegibility;\n  text-transform: uppercase;\n  width: 24px;\n"], ["\n  background-color: ", ";\n  border-radius: 50%;\n  color: #fff;\n  font-family: ", ";\n  font-weight: 600;\n  font-size: 8px;\n  height: 24px;\n  line-height: 1;\n  text-rendering: optimizeLegibility;\n  text-transform: uppercase;\n  width: 24px;\n"])), function (_a) {
    var color = _a.color;
    return color;
}, theme_1.fontFamilies.body);
var templateObject_1;
//# sourceMappingURL=index.js.map